export const deleteAccount = (id) => {
    return (dispatch, getState, getFirebase) => {

        const firebase = getFirebase();

        const userRef = firebase.ref().child(`accounts/${id}`);
        userRef.delete(() => {
        })

    }
}

export const updateCheckedAccounts = (ids) => {
    return {
        type : 'UPDATE_CHECKED_ACCOUNTS',
        payload : {
            ids
        }
    }
}

export const updateAccountApproved = (id, value) => {
    return (dispatch, getState, getFirebase) => {

        const firebase = getFirebase();

        console.log('hahaha');

        const userRef = firebase.ref().child(`accounts/${id}`);
        userRef.child('approved').set(value);
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/AccountManager/actions/accountActions.js